'use strict';

import Alpine from 'alpinejs';
import api from './api';
import { searchForm } from './search-form';
import helper from '../redirect';

export function dashboardView() {
    Alpine.data('dashboard', () => ({
        documents: [],
        documentsFetched: false,
        assistants: null,
        state:'initial',

        init() {
            this.checkPendingRedirection();
            searchForm();
            this.getAssistants();
        },

	getAssistants(cursor = null) {
            let params = {
                limit: 250
            };

            if (cursor) {
                params.starting_after = cursor;
            }

            api.get('/assistants', params)
                .then(response => response.json())
                .then(list => {
		    this.state = 'list';
                    if (!this.assistants) {
                        this.assistants = [];	
                    }

                    this.assistants.push(...list.data);

                    if (list.data.length > 0 && list.data.length == params.limit) {
                        this.getAssistants(this.assistants[this.assistants.length - 1].id);
                    }
                });
        },


        checkPendingRedirection() {
            let path = helper.getRedirectPath();
            if (path) {
                // Remove the redirect path from local storage
                helper.clearRedirectPath();

                // Redirect the user to the path
                window.location.href = path;
            }
        }
    }));
}
